__turbopack_context__.v({
  "brandchip": "brand-chip-module__z9JmdG__brandchip",
});
